import styled from '@emotion/styled';
import { Radio as MuiRadio } from '@mui/material';

export const Radio = styled(MuiRadio)`
  .toggle {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;

    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 6px;
      content: '';
      transform: translate(-50%, -50%) scale(0);
      background-color: #fff;
      border-radius: 50%;
      transition: 0.1s cubic-bezier(0, 0, 0.2, 1);
    }

    &::after {
      width: 16px;
      height: 16px;
      content: '';
      border: 1px solid ${props => props.theme.palette.gray[200]};
      background-color: ${props => props.theme.palette.common.white};
      border-radius: 50%;
      background-color: ${props => props.theme.palette.common.white};
      transition: 0.1s cubic-bezier(0, 0, 0.2, 1);
    }

    &.checked::before {
      transform: translate(-50%, -50%) scale(1);
    }

    &[font-size='small'],
    &.checked[font-size='small'] {
      &::after {
        width: 14px;
        height: 14px;
      }
    }

    &[font-size='large'],
    &.checked[font-size='large'] {
      &::before {
        width: 8px;
        height: 8px;
      }

      &::after {
        width: 18px;
        height: 18px;
      }
    }
  }

  &.Mui-focusVisible {
    .toggle::after {
      box-shadow: 0 0 0 2px ${props => props.theme.palette.primary[300]};
    }
  }

  &.Mui-disabled {
    .toggle::after {
      border-color: ${props => props.theme.palette.gray[200]};
      background-color: ${props => props.theme.palette.gray[75]};
    }
  }

  label:hover:not(.Mui-disabled) &,
  &:hover:not(.Mui-disabled) {
    .toggle::after {
      border: 1px solid ${props => props.theme.palette.gray[300]};
    }
  }

  label:hover:not(.Mui-disabled) &,
  &:hover:not(.Mui-disabled) {
    .toggle:focus {
      border: 1px solid ${props => props.theme.palette.gray[200]};
      box-shadow: 0 0 0 2px ${props => props.theme.palette.primary[300]};
    }
  }

  &:active {
    .toggle {
      &::after {
        border: 1px solid ${props => props.theme.palette.gray[300]};
        background-color: ${props => props.theme.palette.gray[75]};
      }
    }
  }

  .toggle.checked {
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 6px;
      content: '';
      transform: translate(-50%, -50%);
      background-color: #fff;
      border-radius: 50%;
    }

    &::after {
      border-color: ${props => props.theme.palette.primary[500]};
      background-color: ${props => props.theme.palette.primary[500]};
    }
  }

  &.Mui-disabled {
    .toggle.checked {
      &::before {
        background-color: ${props => props.theme.palette.gray[300]};
      }
      &::after {
        border-color: ${props => props.theme.palette.gray[75]};
        background-color: ${props => props.theme.palette.gray[75]};
      }
    }
  }

  label:hover:not(.Mui-disabled) &,
  &:hover:not(.Mui-disabled) {
    .toggle.checked::after {
      border-color: ${props => props.theme.palette.primary[600]};
      background-color: ${props => props.theme.palette.primary[600]};
    }
  }

  &:active {
    .toggle.checked::after {
      border: 1px solid ${props => props.theme.palette.primary[700]};
      background-color: ${props => props.theme.palette.primary[700]};
    }
  }
`;
